<template>
<div class="min-h-screen-50">
	<div class="flex py-2 m-2 px-4">
		<div class="flex-1 text-left">
			<p class="text-lg font-extrabold">Välj kund</p>
		</div>
		<div class="flex-1">
			<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
				<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
			</button>
		</div>
	</div>

	<div class="min-h-screen-50 rounded mx-6 mb-6 pb-2">
		<div class="flex content-between flex-wrap">

			<div class="w-1/5"></div>
			<form class="w-3/5 my-4 bg-white rounded p-2 shadow-md">
				<div class="flex items-center border-b border-b-2 border-green py-2">
					<input class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2 leading-tight focus:outline-none" type="text" placeholder="Sök efter kund" aria-label="Kunduppgifter" autofocus v-model="query">
					<button class="flex-no-shrink border-transparent border-4 text-green hover:text-green-darker text-sm py-1 px-2 rounded" type="button" @click="clearData()">
						Rensa
					</button>
				</div>
			</form>

			<div class="container flex w-1/5 items-center">
				<div v-if="loading" class=" ml-16 w-auto pul-right border border-grey-light bg-white rounded my-4 p-5 shadow-md">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="h-5 w-5 mr-1 fill-current"><path class="heroicon-ui" d="M6 18.7V21a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H7.1A7 7 0 0 0 19 12a1 1 0 1 1 2 0 9 9 0 0 1-15 6.7zM18 5.3V3a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.9A7 7 0 0 0 5 12a1 1 0 1 1-2 0 9 9 0 0 1 15-6.7z"/></svg>
					<p class="inline mb-10"> Söker...</p>
				</div>
			</div>


		</div>

		<div v-if="customers.length" class="border border-grey-light bg-white rounded mx-8 my-8 shadow">
			<div class="flex flex-col w-full">
				<table class="table table-hover table-responsive table-scrollable-50 mb-0 w-full">
					<thead>
						<tr>
							<th>Kundnummer</th>
							<th>Namn</th>
							<th>Adress</th>
							<th>Postort</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="customer in customers" :key="customer.id">
							<td>
								<p class="font-medium" v-text="customer.id"></p>
							</td>
							<td v-text="customer.name + ' ' + customer.last_name"></td>
							<td v-text="customer.adress"></td>
							<td v-text="customer.post_adress"></td>
							<td>
								<div class="px-2 flex justify-center">
									<a href="#" @click="selectCustomer(customer)" class="flex items-center w-1/2 justify-center py-2 text-sm text-center text-white block bg-blue hover:bg-blue-dark rounded shadow-light font-bold">
										Välj
										<svg class="h-3 w-3 ml-1 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
									</a>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		
		<div v-if="!customers.length && !loading" class="container mx-auto flex justify-center border border-grey-light bg-white w-2/5 rounded m-8 p-6 shadow-md">
			<p v-if="query">Inga kunder hittades, var vänlig sök igen</p>
			<p v-else>Sök efter en kund ovan genom att skriva in ett kundnummer</p>
		</div>

	</div>
</div>
</template>

<script>

import _ from 'lodash'
import axios from 'axios'

export default {
	
	data() {
		return {
			customers: [],
			query: '',
			debounceQuery: null,
			loading: false,
		}
	},

	mounted() {
        /**
         * Debounce when the user writes a query
         */
        this.debounceQuery = _.debounce(function() {
            this.searchCustomers()
        }, 250)
	},

	watch: {
		query() {
			if(this.query != '') {
				this.loading = true
				this.debounceQuery()
			} else {
				this.clearData()
			}
		}
	},

	methods: {

		searchCustomers() {
			axios.post('/customer/search', {
				q: this.query
			})
			.then(response => {
				this.loading = false
				this.customers = response.data
			})

		},

		clearData() {
			this.loading = false
			this.query = ''
			this.customers = []
		},

		selectCustomer(customer) {
			this.$store.dispatch("customer/SET_CUSTOMER", customer)
		},

		dismissModal() {
			this.$emit('closeModal')
		}

	}
}
</script>